window.__assetPrefix__ = 'https://d3cwo1al8xsdqd.cloudfront.net/analytics-hub';